import { Tipologia, TipologiasInterface } from 'app/models/tipologias.model';
import { ApiService } from '../../../core/services/apiservice';
import { Injectable } from '@angular/core';
import { Usuarios } from 'app/models/usuarios.model';
import { ReporteParams, BienesCulturalesReporte,
  SolicitudesReporte,
  GestionesReporte,
  DocumentosOficialesReporte } from './models/resportes.model';
import { PlantillasResponse } from '../documentos-oficiales/models/plantillas.model';

@Injectable({providedIn: 'root'})
export class ReportesService {

    constructor(private apiService:ApiService) { }

    getTipologias(tipologia_id:number): Promise<Tipologia[]>{
        const url= `/tipologias/${tipologia_id}` 
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error obtener tipología.')
                .subscribe((response:TipologiasInterface) => {
                    resolve(response[0].tipologias)  
                }, error => {
                    reject(error)
                })
        })
    }

    getTipologiasFormularios(tipologia:number){
        const url=`/tipologias/${tipologia}`
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, {}, 'Error al obtener los datos.')
                .subscribe((response: TipologiasInterface) => {
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    getUsuarios(params?:any){
        const url='/users'
        return new Promise((resolve, reject)=>{
            this.apiService.GetMethod(url, params, 'Error al obtener los datos.')
                .subscribe((response: Usuarios) => {
                    resolve(response)                    
                }, error => {
                    reject(true)
                })
        })
    }

    construirInstanciaReporte(tipo: string, params: ReporteParams): any {
        switch (tipo) {
            case 'bienes-culturales':
            return new BienesCulturalesReporte(params);
            case 'solicitudes':
            return new SolicitudesReporte(params);
            case 'gestiones':
            return new GestionesReporte(params);
            case 'documentos-oficiales':
            return new DocumentosOficialesReporte(params);
        }
    }

    getPlantillas(seccion_uuid:number){
            const params= {seccion: seccion_uuid}
            const url=`/plantillas` 
            return new Promise((resolve, reject)=>{
                this.apiService.GetMethod(url, params, 'Error al obtener las plantillas.')
                    .subscribe((response: PlantillasResponse) => {
                        resolve(response.data)                    
                    }, error => {
                        reject(true)
                    })
            })
        }

    
}